import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import DocumentDownloadItem from "./DocumentDownloadItem";
import { formatCurrency, isPrateleiraInfinita } from "./utils";

const useStyles = makeStyles({
  wrapper: {
    backgroundColor: themeColorsDesingSystem.background.main,
    border: `1px solid ${themeColorsDesingSystem.stone.main}`,
    borderRadius: 4,
    overflow: "hidden",
  },
  header: {
    backgroundColor: themeColorsDesingSystem.stone.light,
    padding: "0.75rem 1rem",
    borderBottom: `1px solid ${themeColorsDesingSystem.stone.main}`,
  },
  headerTitle: {
    fontSize: "0.875rem",
    fontWeight: 700,
    color: themeColorsDesingSystem.gray.dark,
  },
  content: {
    padding: "1.25rem 1.5rem",
  },
  detailRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "0.5rem 1rem",
    marginBottom: "0.5rem",
    fontSize: "0.8125rem",
  },
  detailLabel: {
    textAlign: "right",
    color: themeColorsDesingSystem.gray.dark,
    fontWeight: 600,
  },
  detailValue: {
    color: themeColorsDesingSystem.text.primary,
    fontWeight: 500,
  },
  documentsTitle: {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: themeColorsDesingSystem.gray.dark,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    marginBottom: "1rem",
    textAlign: "center",
  },
  documentsSection: {
    height: "100%",
    paddingLeft: 0,
    "@media (min-width: 960px)": {
      paddingLeft: "1.5rem",
      borderLeft: `1px dashed ${themeColorsDesingSystem.stone.medium}`,
    },
  },
});

function DetailRow({ label, value }) {
  const classes = useStyles();

  return (
    <Box className={classes.detailRow}>
      <Typography className={classes.detailLabel}>{label}</Typography>
      <Typography className={classes.detailValue}>{value}</Typography>
    </Box>
  );
}

export default function OrderDetailPanel({ pedido }) {
  const classes = useStyles();
  const detalhe = pedido?.detalhe ?? {};
  const documentos = detalhe.documentos ?? {};
  const isPI = isPrateleiraInfinita(pedido?.canal);
  const percentualComissao = detalhe.percentualComissao
    ? ` (${detalhe.percentualComissao}%)`
    : "";

  const documentItems = [
    {
      key: "nota-servico",
      label: "Nota de Serviço",
      disponivel: documentos.notaServico?.disponivel,
      tipo: "nota",
      chaveNf: documentos.notaServico?.chaveNf,
      formatoArquivo: documentos.notaServico?.formatoArquivo,
      pdfNoS3: documentos.notaServico?.pdfNoS3,
      xmlNoS3: documentos.notaServico?.xmlNoS3,
      preferXml: true,
    },
    {
      key: "nota-venda-produto",
      label: "Nota venda produto",
      disponivel: isPI && documentos.notaVendaProduto?.disponivel,
      tipo: "nota",
      chaveNf: documentos.notaVendaProduto?.chaveNf,
      formatoArquivo: documentos.notaVendaProduto?.formatoArquivo,
      pdfNoS3: documentos.notaVendaProduto?.pdfNoS3,
      xmlNoS3: documentos.notaVendaProduto?.xmlNoS3,
      preferXml: false,
    },
    {
      key: "boleto-comissao",
      label: "Boleto Comissão",
      disponivel: isPI && documentos.boletoComissao?.disponivel,
      tipo: "boleto",
      numeroTitulo: documentos.boletoComissao?.numeroTitulo,
    },
    {
      key: "boleto-venda",
      label: "Boleto Venda",
      disponivel: isPI && documentos.boletoVenda?.disponivel,
      tipo: "boleto",
      numeroTitulo: documentos.boletoVenda?.numeroTitulo,
    },
  ];

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.header}>
        <Typography className={classes.headerTitle}>Resumo do Pedido</Typography>
      </Box>

      <Box className={classes.content}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <DetailRow label="Pedido:" value={pedido?.numeroPedido ?? "-"} />
            <DetailRow label="Canal:" value={pedido?.canal ?? "-"} />
            <DetailRow
              label="Valor total do pedido:"
              value={formatCurrency(pedido?.valorTotalPedido)}
            />
            <DetailRow
              label="Frete:"
              value={formatCurrency(detalhe.frete)}
            />
            <DetailRow
              label={`Valor Comissão${percentualComissao}:`}
              value={formatCurrency(pedido?.valorComissao)}
            />
            <DetailRow
              label="Venda Sell-in:"
              value={formatCurrency(detalhe.vendaSellIn)}
            />
            <DetailRow
              label="Venda Loja:"
              value={formatCurrency(detalhe.vendaLoja)}
            />
            <DetailRow
              label="Venda Marca:"
              value={formatCurrency(detalhe.vendaMarca)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Box className={classes.documentsSection}>
              <Typography className={classes.documentsTitle}>
                Documentos
              </Typography>
              <Grid container spacing={1}>
                {documentItems.map((doc) => (
                  <Grid item xs={6} key={doc.key}>
                    <DocumentDownloadItem
                      label={doc.label}
                      disponivel={doc.disponivel}
                      tipo={doc.tipo}
                      chaveNf={doc.chaveNf}
                      numeroTitulo={doc.numeroTitulo}
                      formatoArquivo={doc.formatoArquivo}
                      pdfNoS3={doc.pdfNoS3}
                      xmlNoS3={doc.xmlNoS3}
                      preferXml={doc.preferXml}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
